<template>
  <div class="share-actions">
    <div class="sharing__button" :class="address ? 'active' : ''">
      <a
        :class="['share-button', 'share-button--url', shared ? 'shared' : '']"
        @click="shareLink"
        data-copy-text="Copied!"
        >Share Address</a
      >
      <a class="share-button share-button--google" :href="googleMapsLink"
        >Google Maps</a
      >
      <a
        class="share-button share-button--apple"
        :href="appleMapsLink"
        v-if="isApplePlatform"
        >Apple Maps</a
      >
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { round, sendEvent } from '@/helpers';

export default {
  props: ['address'],
  data() {
    return {
      shared: false,
    };
  },
  computed: {
    ...mapState(['location']),
    encodedTitle() {
      if (!this.address || typeof this.address.formattedAddress !== 'string') {
        return null;
      }
      return encodeURIComponent(this.address.formattedAddress.replace(/\s/g, '+'));
    },
    latLng() {
      return `${round(this.location.latitude, 5)},${round(this.location.longitude, 5)}`;
    },
    googleMapsLink() {
      return `https://www.google.com/maps/place/${this.encodedTitle}/@${this.latLng}`;
    },
    appleMapsLink() {
      return `https://maps.apple.com/place/?address=${this.encodedTitle}&ll=${this.latLng}`;
    },
    isApplePlatform() {
      return typeof navigator !== 'undefined' && RegExp('iPhone|iPad|iPod|Mac').test(navigator.platform);
    },
  },
  methods: {
    shareLink() {
      if (!this.address || typeof this.address.formattedAddress !== 'string') {
        return;
      }
      sendEvent('share', 'link');
      const title = this.address.formattedAddress;
      if (typeof navigator.share === 'undefined') {
        navigator.clipboard.writeText(title);
        this.shared = true;
        setTimeout(() => { this.shared = false; }, 1000);
        return;
      }
      navigator.share({
        title,
      });
    },
  },
};
</script>
